export const RESET_CLUB_PACKAGE_ISFETCHING = 'RESET_CLUB_PACKAGE_ISFETCHING';
export const CLUB_PACKAGE_REQUESTING = 'CLUB_PACKAGE_REQUESTING';
export const GET_CLUB_PACKAGE_BY_CLUBID_REQUEST =
  'GET_CLUB_PACKAGE_BY_CLUBID_REQUEST';
export const GET_CLUB_PACKAGE_SUCCESS = 'GET_CLUB_PACKAGE_SUCCESS';
